import React from "react";

import { i18next } from "@translations/invenio_rdm_records/i18next";
import { ArrayField } from "../react_invenio_forms/ArrayField";
import RepeatableFieldRow from "./RepeatableFieldRow";

const RepeatableField = ({ fieldPath, fieldConfig, templateLoaders }) => {
  const isNested = !!fieldConfig.props.fields;
  const defaultValues = isNested
    ? fieldConfig.props.fields.reduce((result, current) => {
        result[current.name] = "";
        return result;
      }, {})
    : "";

  return (
    <ArrayField
      addButtonLabel={i18next.t("Add new")}
      defaultNewValue={defaultValues}
      fieldPath={fieldPath}
      label={fieldConfig.props.label}
      labelIcon={fieldConfig.props.icon}
      showEmptyValue
    >
      {({ arrayHelpers, indexPath }) => (
        <RepeatableFieldRow
          key={`${fieldPath}[${indexPath}]`}
          fieldConfig={fieldConfig}
          fieldPath={fieldPath}
          templateLoaders={templateLoaders}
          indexPath={indexPath}
          arrayHelpers={arrayHelpers}
        />
      )}
    </ArrayField>
  );
};

export default RepeatableField;
